module.exports = __webpack_public_path__ + "img/Icon-block-segment-32px.668fe905.svg";